import { ExecuteWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  SchemaProvider,
  WorkflowNodeSchemaProvider,
} from '../../registry/schema-provider.registry';

@WorkflowNodeSchemaProvider('ExecuteWorkflow')
export class ExecuteWorkflowNodeSchemaProvider extends SchemaProvider<ExecuteWorkflowNode> {}
